import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { serviceDetails } from '../data/serviceDetails';

function Gearboxes() {
  return <ServiceDetailPage service={serviceDetails.gearboxes} />;
}

export default Gearboxes;
